import { Box, CircularProgress, Container, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import UserCard from '../components/cards/UserCard'
import { useUsers } from '../contexts/UserContext'

export default function UserView({ userId }) {
  const params = useParams()
  const id = userId || params.id
  const { fetchUser } = useUsers()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const loadUser = async () => {
      try {
        setLoading(true)
        setError(null)
        const userData = await fetchUser({ userId: id })
        // Transform API response to match UserCard format
        setUser({
          value: userData.resourceId,
          name: `${userData.firstName} ${userData.lastName}`,
          avatar: userData.avatar,
          email: userData.email,
          sports: userData.sports || [],
          certificates: userData.instructorCertificates || [],
          certificateVerified: userData.certificateVerified,
          bio: userData.bio,
        })
      } catch (error) {
        console.error('Error loading user:', error)
        setError('Failed to load user data')
      } finally {
        setLoading(false)
      }
    }

    if (id) {
      loadUser()
    }
  }, [id, fetchUser])

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      </Container>
    )
  }

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ py: 4 }}>
          <Typography color="error" align="center">
            {error}
          </Typography>
        </Box>
      </Container>
    )
  }

  if (!user) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ py: 4 }}>
          <Typography align="center">User not found</Typography>
        </Box>
      </Container>
    )
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <UserCard clickable={false} user={user} size="large" />
      </Box>
    </Container>
  )
}
